<template>

    <button :style="{height: customHeight}" :disabled="disabled || isLoading" :aria-busy="isLoading ? 'true' : null"
        :aria-label="!text && tooltip ? tooltip : null" v-tooltip="tooltipConfig" :type="(submit) ? 'submit' : 'button'"
        class="btn" :class="buttonClasses">

        <div v-if="!isLoading" class="d-flex gap-1" :class="buttondivClasses">
            <i v-if="icon" :class="icon"></i>
            <span v-if="text">{{ text }}</span>
        </div>

        <div v-else  class="d-flex gap-1" :class="buttondivClasses" >
            <i class="ri-restart-line rotate"></i>
            <span v-if="loadingText">{{ loadingText }}</span>
        </div>

    </button>

</template>

<script>
/**
 * Botão padrão do sistema.
 *
 * Variantes (`type`): `primary` (ação principal, cor da marca), `success`
 * (confirmar/salvar), `danger`, `warning`, `info`, `light`/`secondary`
 * (superfície com borda), `ghost` (sem fundo), `outline-primary`,
 * `outline-secondary`, `outline-danger`. A aparência de cada uma no admin
 * vive em `assets/css/admin.css` (seção "Botões"); aqui só se escolhe a classe.
 */
export default {
  props: {
    text: {
      type: String
    },
    type: {
      type: String,
      default: 'info'
    },
    size: {
      type: String
    },
    icon: {
      type: String
    },
    submit: {
      type: Boolean,
      default: false
    },
    disabled: {
      type: Boolean,
      default: false
    },
    alignText: {
      type: String,
      default: 'center'
    },
    widthMax: {
      type: Boolean,
      default: false
    },
    isLoading: {
      type: Boolean,
      default: false
    },
    loadingText: {
      type: String
    },
    tooltip: {
      type: String
    },
    totooltipPlacement: {
      type: String,
      default: 'top'
    },
    customHeight:{
      type: String,
      required: false
    }
  },
  data () {
    return {
      senhaVisivel: false
    }
  },
  computed: {
    buttonClasses () {
      return {
        'btn-primary': this.type == 'primary',
        'btn-info': this.type == 'info',
        'btn-danger': this.type == 'danger',
        'btn-success': this.type == 'success',
        'btn-warning': this.type == 'warning',
        'btn-light': this.type == 'light' || this.type == 'secondary',
        'btn-ghost': this.type == 'ghost',
        'btn-outline-primary': this.type == 'outline-primary',
        'btn-outline-secondary': this.type == 'outline-secondary' || this.type == 'outline',
        'btn-outline-danger': this.type == 'outline-danger',
        'btn-sm': this.size == 'small',
        'btn-lg': this.size == 'large',
        'btn-icon-only': !this.text && !!this.icon,
        'w-100': this.widthMax
      }
    },
    buttondivClasses () {
      return {
        'justify-content-start': this.alignText == 'left',
        'justify-content-center': this.alignText == 'center',
        'justify-content-end': this.alignText == 'rigth'
      }
    },
    tooltipConfig () {
      return { content: this.tooltip, placement: this.totooltipPlacement }
    }
  },
  methods: {
  }
}
</script>
